export function later(ms: number) {
    return new Promise<void>((resolve) => {
        setTimeout(() => resolve(), ms);
    });
}

export function neverResolve(): Promise<never> {
    return new Promise<never>(() => {
        // This promise will never resolve
    });
}

const div = document.createElement("div");

export function e(text: string): string {
    div.innerText = text;
    return div.innerHTML;
}
